/* eslint-env browser */

import React from 'react';
import { render } from 'react-dom';
import { assign } from 'lodash';
import Header from './Header';

const {
  headerFeaturedLink,
  headerFeaturedTitle,
  headerFeaturedDescription,
  headerFeaturedCTA,
  headerFeaturedIconColor,
  talkToSalesButtonText,
  headerData,
  abExperiments
} = window.APP_STATE;

const headerProps = {
  featuredLink: headerFeaturedLink,
  featuredTitle: headerFeaturedTitle,
  featuredDescription: headerFeaturedDescription,
  featuredCTA: headerFeaturedCTA,
  featuredIconColor: headerFeaturedIconColor,
  talkToSalesButtonText,
  headerData,
  abExperiments
};

export default props =>
  render(
    <Header {...assign(props, headerProps)} />, document.getElementById('header'));

export { Header };



// WEBPACK FOOTER //
// ./src/modules/header/client.js